import React from "react";

// All pages that rely on 3rd party components (other than Material-UI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";

// Guards
import AuthGuard from "./components/guards/AuthGuard";

// Auth components
import Page404 from "./pages/auth/Page404";
import AuthCallback from "./pages/auth/AuthCallback";
import SilentCallback from "./pages/auth/SilentCallback";

// Components

// DMG Pages
import DevicesDashboard from "./pages/device/DevicesDashboard";
// Form components

// Icon components

// Page components

// Table components

// Documentation

// Landing

// Device pages
import AddDevice from "./pages/device/AddDevice";
import ProvisionDevices from "./pages/device/ProvisionDevices";
import Device from "./pages/device/Device";
import EditDevice from "./pages/device/EditDevice";
import ApiKeys from "./pages/settings/ApiKeys";
import Organizations from "./pages/settings/Organizations";
import { Navigate } from "react-router-dom";

const routes = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Navigate replace to="/devices" />,
      },
    ],
  },
  {
    path: "devices",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <DevicesDashboard />,
      },
      {
        path: "add",
        element: <AddDevice />,
      },
      {
        path: "provision",
        element: <ProvisionDevices />,
      },
      {
        path: ":serialNumber",
        children: [
          {
            path: "",
            element: <Device />,
          },
          {
            path: "edit",
            element: <EditDevice />,
          },
        ],
      },
    ],
  },
  {
    path: "settings",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "api-keys",
        element: <ApiKeys />,
      },
      {
        path: "organizations",
        element: <Organizations />,
      },
    ],
  },
  {
    path: "authentication",
    children: [
      {
        path: "callback",
        element: <AuthCallback />,
      },
      {
        path: "silent-callback",
        element: <SilentCallback />,
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
